import { useState } from 'react';
import { setTrim } from '../../lib/common';
import { useCouponIssueHistoryListQuery } from '../queries/coupon/useCouponIssueHistoryListQuery';

type IssueHistorySearchData = {
  couponIssueHistoryId: string | null;
  adminIdList: number[];
  memo: string | null;
  createDate: { startDate: string | null; endDate: string | null };
};

const INITIAL_SEARCH_DATA: IssueHistorySearchData = {
  couponIssueHistoryId: null,
  adminIdList: [],
  memo: null,
  createDate: { startDate: null, endDate: null },
};

const INITIAL_PAGINATION = { pageNum: 0, pageSize: 20 };

export const useCouponIssueHistoryList = () => {
  const [searchData, setSearchData] = useState<IssueHistorySearchData>(INITIAL_SEARCH_DATA);
  const [searchOption, setSearchOption] = useState<Record<string, unknown>>({});
  const [pagination, setPagination] = useState(INITIAL_PAGINATION);

  const { data, isLoading, error } = useCouponIssueHistoryListQuery({
    searchOption,
    pagination,
  });

  const onSearch = () => {
    setSearchOption({
      couponIssueHistoryId: setTrim(searchData.couponIssueHistoryId),
      adminIdList: searchData.adminIdList,
      memo: setTrim(searchData.memo),
      createDate: searchData.createDate,
    });
    setPagination(INITIAL_PAGINATION);
  };

  const onClear = () => {
    setSearchData(INITIAL_SEARCH_DATA);
    setSearchOption({});
    setPagination(INITIAL_PAGINATION);
  };

  const onSearchDataChange = (path: string, value: unknown) => {
    setSearchData((prev) => ({ ...prev, [path]: value }));
  };

  const onPageChange = (pageNum: number, pageSize: number) => {
    setPagination({ pageNum, pageSize });
  };

  return {
    list: data?.list ?? [],
    totalCount: data?.totalCount ?? 0,
    adminSelectList: data?.adminSelectList ?? [],
    pagination: data?.pagination ?? { ...INITIAL_PAGINATION, pages: 1 },
    searchData,
    isLoading,
    error,
    onSearch,
    onClear,
    onSearchDataChange,
    onPageChange,
  };
};
